<div
  class="character-container bg-{{ characterSlot?.sequenceNumber }}"
  [ngClass]="{ withoutFrame: hideFrame }"
  (click)="openCharacterSelection()"
>
  <ng-container *ngIf="characterSlot">
    <app-character-skin
      [config]="characterSlot.character?.skin"
    ></app-character-skin>
  </ng-container>
  <div
    *ngIf="!hideFrame"
    [ngClass]="{
      slim: slimFrame,
      bold: boldFrame && characterSlot,
      unselected: boldFrame && !characterSlot
    }"
    class="borders"
  ></div>
  <div class="text" *ngIf="showName">{{ characterSlot?.character?.name }}</div>
</div>
